import './fonts';
import { createRoot } from 'react-dom/client';
import { getSession, initSession, loadCounters } from '@tg/app-core';
import './styles/theme-01-strava.css';
import './styles/app.css';
import './styles/extra.css';
import { App } from './App';
import { DataProvider } from './lib/query';
import { lsSet } from './lib/storage';
import { applyTheme } from './lib/theme';

initSession('client');
/* Тема — до первого кадра, чтобы не мигало светлым */
applyTheme();

/* Ссылка тренера: https://trener.my/j/<код> (основной формат), ?invite=CODE,
   #/phone?invite=CODE или #/j/<код>. Роутинг в хеше, поэтому путь /j/<код>
   разбираем здесь. Уже вошедшему — не на экран входа: код откладывается
   в pendingInvite, Shell (App.tsx) привязывает тренера и уводит на главную,
   как только приложение поднимется. Новому — как раньше, через #/phone. */
{
  const h = window.location.hash;
  const code =
    (window.location.pathname.match(/\/j\/([\w-]+)/) || [])[1] ||
    new URLSearchParams(window.location.search).get('invite') ||
    new URLSearchParams(h.split('?')[1] || '').get('invite') ||
    (h.match(/^#\/j\/([\w-]+)/) || [])[1];
  if (code) {
    if (getSession()) {
      lsSet('pendingInvite', code);
      window.history.replaceState(null, '', import.meta.env.BASE_URL + '#/');
    } else {
      lsSet('invite', code);
      window.history.replaceState(null, '', import.meta.env.BASE_URL + '#/phone');
    }
  }
}

/* Service worker — только в браузере: в Capacitor файлы и так в приложении */
const native = !!(window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.();
if (!native && import.meta.env.PROD && 'serviceWorker' in navigator) {
  import('virtual:pwa-register').then(({ registerSW }) => registerSW({ immediate: true })).catch(() => {});
}

createRoot(document.getElementById('root')!).render(
  <DataProvider>
    <App />
  </DataProvider>,
);
/* Коды счётчиков из админки (Метрика, Mixpanel…) — после первого показа */
loadCounters('client');
